import React__default from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var PlusIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React__default.createElement("svg", _extends({
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("text", {
    transform: "translate(-1 -220)",
    fill: "#3d4e56",
    fillRule: "evenodd",
    fontFamily: "CircularStd-Book, Circular Std",
    fontSize: "24",
    fontWeight: "300"
  }, React__default.createElement("tspan", {
    x: "0",
    y: "233"
  }, "+")));
});

export default PlusIcon;
//# sourceMappingURL=plus.svg.js.map
